<section
  class="py-12 sm:py-16 lg:py-24 border-b transition-colors"
  [ngClass]="theme === 'warm' ? 'bg-[#faf6f0] border-stone-200 text-stone-900' : (theme === 'bold' ? 'bg-slate-950 text-white border-blue-950' : 'bg-base-200/50 border-base-300')"
>
  <div class="container mx-auto px-4 sm:px-6 max-w-6xl">
    
    <!-- Section Header -->
    <div class="text-center max-w-2xl mx-auto mb-8 sm:mb-14">
      <div
        class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3"
        [ngClass]="theme === 'warm' ? 'bg-amber-500/15 text-amber-900 border border-amber-400/40' : (theme === 'bold' ? 'bg-red-600/20 text-red-300 border border-red-500/40' : 'bg-amber-500/10 text-amber-600 dark:text-amber-400')"
      >
        <i class="fa-solid fa-star"></i>
        <span>Social Proof</span>
      </div>
      <h2
        class="text-2xl sm:text-4xl font-extrabold tracking-tight break-words px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
      >
        {{ title }}
      </h2>
      <p
        class="text-sm sm:text-base mt-3 leading-relaxed px-2"
        [ngClass]="theme === 'warm' ? 'text-stone-600' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/70')"
      >
        Real feedback and results from students and parents enrolled in our batches.
      </p>
    </div>

    <!-- Testimonials Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      @for (item of items; track $index) {
        <div
          class="daisy-card border shadow-md p-5 sm:p-8 rounded-2xl sm:rounded-3xl flex flex-col justify-between hover:shadow-xl transition-all"
          [ngClass]="theme === 'warm' ? 'bg-[#fffdfa] border-stone-200 text-stone-800' : (theme === 'bold' ? 'bg-slate-900 border-blue-900/50 text-white' : 'bg-base-100 border-base-300')"
        >
          <div class="space-y-4">
            
            <!-- Stars & Quote mark -->
            <div class="flex items-center justify-between text-amber-400">
              <div class="flex gap-1 text-sm">
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </div>
              <i
                class="fa-solid fa-quote-right text-2xl"
                [ngClass]="theme === 'warm' ? 'text-stone-300' : (theme === 'bold' ? 'text-slate-700' : 'text-base-content/15')"
              ></i>
            </div>

            <!-- Quote Text -->
            <p
              class="text-sm sm:text-base leading-relaxed italic"
              [ngClass]="theme === 'warm' ? 'text-stone-700' : (theme === 'bold' ? 'text-slate-300' : 'text-base-content/80')"
            >
              "{{ item.quote }}"
            </p>
          </div>

          <!-- Student Profile Footer -->
          <div
            class="pt-6 mt-6 border-t flex items-center gap-3"
            [ngClass]="theme === 'warm' ? 'border-stone-200' : (theme === 'bold' ? 'border-slate-800' : 'border-base-200')"
          >
            <div
              class="w-10 h-10 rounded-full font-bold flex items-center justify-center shrink-0 text-sm overflow-hidden"
              [ngClass]="theme === 'warm' ? 'bg-amber-100 text-amber-800' : (theme === 'bold' ? 'bg-red-500/20 text-red-400' : 'bg-primary/10 text-primary')"
            >
              @if (item.avatarUrl) {
                <img [src]="item.avatarUrl" [alt]="item.name" class="w-full h-full object-cover" />
              } @else {
                <span>{{ item.name.charAt(0) }}</span>
              }
            </div>
            <div class="min-w-0">
              <h4
                class="text-sm font-bold truncate"
                [ngClass]="theme === 'warm' ? 'text-stone-900' : (theme === 'bold' ? 'text-white' : 'text-base-content')"
              >{{ item.name }}</h4>
              @if (item.achievement) {
                <span
                  class="inline-block text-[11px] font-semibold px-2 py-0.5 rounded-md mt-0.5"
                  [ngClass]="theme === 'warm' ? 'text-amber-800 bg-amber-100/80' : (theme === 'bold' ? 'text-red-300 bg-red-600/20 font-bold' : 'text-emerald-600 dark:text-emerald-400 bg-emerald-500/10')"
                >
                  {{ item.achievement }}
                </span>
              }
            </div>
          </div>

        </div>
      }
    </div>

  </div>
</section>
